import { render } from "./FairWarning.vue?vue&type=template&id=840393ac&scoped=true"
import script from "./FairWarning.vue?vue&type=script&lang=js"
export * from "./FairWarning.vue?vue&type=script&lang=js"

import "./FairWarning.vue?vue&type=style&index=0&id=840393ac&scoped=true&lang=css"

import exportComponent from "/Users/remy/Sites/baghera/WocUp/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840393ac"]])

export default __exports__